enum apiKey {
  patchResetPassword = ' patchResetPassword',
  getSearchProducts = 'getSearchProducts',
  login = 'login',
  getRefreshToken = 'getRefreshToken',
  louout = 'logout',
  carousel = 'carousel',
  getRefresh = 'getRefresh',
  googleSpreadSheet = 'googleSpreadSheet',
  getResetPasswordToken = 'getResetPasswordToken',
  getAccountPermission = 'getAccountPermission',
  //custom service//
  getOhterDetail = 'getOhterDetail',
  getFaq = 'getFaq',
  getNews = 'getNews',
  getNewsDetail = 'getNewsDetail',
  getContactDetail = 'getContactDetail',
  //custom service//
  getCustomer = 'getCustomer',
  getCustomerDetal = 'getCustomerDetal',
  getDealer = 'getDealer',
  getCustomerPermission = 'getCustomerPermission',
  createCustomer = 'createCustomer',
  createCompanyOrDealer = 'createCompanyOrDealer',
  updateCustomer = 'updateCustomer',
  updateCompanyOrDealer = 'updateCompanyOrDealer',
  sendOpenAccountEmail = 'sendOpenAccountEmail',
  getCompanyDetail = 'getCompanyDetail',
  getERPCompany = 'getERPCompany',
  //product//
  getProductDetail = 'getProductDetail',
  getLensSettingLeft = 'getLensSettingLeft',
  postOrderCart = 'postOrderCart',
  getLensSettingRight = 'getLensSettingRight',
  getPatientList = 'getPatientList',
  getTintNPlasma = 'getTintNPlasma',
  getLensCalculate = 'getLensCalculate',
  createPatient = 'createPatient',
  getOrders = 'getOrders',
  getPatientDetail = 'getPatientDetail',
  getDesignDefault = 'getDesignDefault',

  // index
  getBanner = 'getBanner',
  getOrderOften = 'getOrderOften',

  // cart
  getOrderLens = 'getOrderLens',
  getOrderOthers = 'getOrderOthers',
  getOrdererInfor = 'getOrdererInfor',
  deleteOrder = 'deleteOrder',

  //orders
  getCompany = 'getCompany',
  getOrdersList = 'getOrdersList',
  getOrdersDetail = 'getOrdersDetail',
  orderVerify = 'orderVerify',
  cancelOrder = 'cancelOrder',
  getOrdersStatusCount = 'getOrdersStatusCount',
  getConsultationList = 'getConsultationList',
  completeOrder = 'completeOrder',
  getPendingShipmentList = 'getPendingShipmentList',
  mergeOrder = 'mergeOrder',
  getOtherShipmentList = 'getOtherShipmentList',
  mergeConfirm = 'mergeConfirm',
  mergeOrderDelete = 'mergeOrderDelete',
  reorder = 'reorder',
  postFiles = 'postFiles',
  postVideos = 'postVideos',
  postOrder = 'postOrder',
  getCorneaView = 'corneaView',
  getSectionLineView = 'sectionLineView',
  getCorneaEye = 'corneaEye',
  getAuAPI2 = 'au_api2',
  // Start 為了還原模擬適配mockup版本
  getSectionLineSliceFs = 'sectionLineSliceFs',
  getSectionLine = 'sectionLine',
  // End

  //patient
  getPatientsList = 'getPatientsList',
  createPatientData = 'createPatientData',
  postRiskLevel = 'postRiskLevel',
  postCorneaFile = 'postCorneaFile',
  postCorneaImages = 'postCorneaImages',
  postCorneaDefaultRenew = 'postCorneaDefaultRenew',
  getCornealDefaultRenew = 'getCornealDefaultRenew',
  getPatientDetailInfo = 'getPatientDetailInfo',
  closePatient = 'closePatient',
  getPatientHistory = 'getPatientHistory',
  getCorneaHistory = 'getCorneaHistory',
  updatePatientData = 'updatePatientData',
  deleteCorneaFiles = 'deleteCorneaFiles',

  //presets
  getPresetsList = 'getPresetsList',
  createPreset = 'createPreset',
  closePreset = 'closePreset',
  importPreset = 'importPreset',
  updatePresetData = 'updatePresetData',

  getAccountInfo = 'getAccountInfo',

  getProductType = 'getProductType',
  deleteCorneal = 'deleteCorneal',
  updateCornealNote = 'updateCornealNote',
  updateCornealTime = 'updateCornealTime',
  getPatientMyopia = 'getPatientMyopia',
  closePatientMyopia = 'closePatientMyopia',
  updatePatientMyopiaData = 'updatePatientMyopiaData',
  createPatientMyopia = 'createPatientMyopia',
  getCornealDetail = 'getCornealDetail',
}

export default apiKey
